export function getInitials(nameOrEmail) {
  const raw = String(nameOrEmail || "").trim();
  if (!raw) return "U";

  const base = raw.includes("@") ? raw.split("@")[0] : raw;
  const cleaned = base.replace(/[^a-zA-Z0-9\s]/g, " ").trim();
  if (!cleaned) return raw.slice(0, 2).toUpperCase();

  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  const first = parts[0][0] || "";
  const last = parts[parts.length - 1][0] || "";
  return `${first}${last}`.toUpperCase();
}
